module.exports = __webpack_public_path__ + "img/cat-pos.c8250d9d.png";